import React, { useState } from "react";
import StatsCard from "../UI/staticsCard";
import DataTable from "../UI/table/DataTable";
import { useQuery } from "react-query";
import { getCurios, getCuriosStats } from "../../MyApi/curior";
import {
  curiorColumns,
  curiorStatsConfig,
} from "../../pages/shipping/shippingdata";
import FilterBar from "../UI/filterbar";
import StartCourierWorkModal from "./startWorkModal";

const CourierTab = ({ onAddClick }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    company: "",
    status: "",
  });
  const [showStartShiftModal, setShowStartShiftModal] = useState(false);

  const { data: curiorStatsData, isLoading: isLoadingCurioerStatics } =
    useQuery("getcuriorStats", getCuriosStats);
  const {
    data: curiorsData,
    isLoading: isCuriorLoading,
    isFetching,
    error,
  } = useQuery(["getCurios", currentPage, filters], () =>
    getCurios("", currentPage, filters),
  );

  const curiors = curiorsData?.data?.couiers || [];
  const curiorStats = curiorStatsData?.data || {};
  const totalCuriorItems = curiorsData?.data?.pagination?.total || 0;
  const lastCuriorPage = curiorsData?.data?.pagination?.last_page || 0;

  const curiorInfoStats = curiorStatsConfig(curiorStats);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1); // Reset to first page when filters change
  };

  const handleResetFilters = (resetFilters) => {
    setFilters(resetFilters);
    setCurrentPage(1);
  };

  return (
    <>
      <div className="row g-3 mt-3">
        {curiorInfoStats?.map((stat, index) => (
          <div className="col-md" key={index}>
            <StatsCard {...stat} isLoading={isLoadingCurioerStatics} />
          </div>
        ))}
      </div>

      <FilterBar
        filters={filters}
        setFilters={setFilters}
        onFilterChange={handleFilterChange}
        onResetFilters={handleResetFilters}
        filtersConfig={{
          search: true,
          company: true,
          status: true,
        }}
        placeholder="بحث عن سائق"
      />

      <div className="mt-4">
        <DataTable
          columns={curiorColumns}
          data={curiors}
          title={"السائقين"}
          // actionLabel={"إضافة سائق جديد"}
          actionButtons={[
            {
              label: "إضافة سائق جديد",
              onClick: onAddClick,
              permission: "create_couier",
            },
            {
              label: "بدء دوام",
              onClick: () => setShowStartShiftModal(true),
            },
          ]}
          emptyMessage="لا توجد بيانات للسائقين "
          onAddClick={onAddClick}
          itemsPerPage={lastCuriorPage}
          totalItems={totalCuriorItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isLoading={isCuriorLoading}
          createPermission={"create_couier"}
          isFetching={isFetching}
          error={error}
        />
      </div>

      <StartCourierWorkModal
        show={showStartShiftModal}
        onClose={() => setShowStartShiftModal(false)}
      />
    </>
  );
};

export default CourierTab;
